import { Outlet } from 'react-router-dom';

export default function LayoutsPageLayout() {
    return (
        <>
            <Outlet />
        </>
    );
}
